import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';

class LoadCertificationTestItemService {
  fetch = new FetchService();
  constructor() {
    extendObservable(this, {
      certificationTestItem: null,
    });
  }

  handleLoad = action(async (certificationTestId, itemId) => {
    const { item, certificationTestCourseAbility } = await this.fetch.fetch({
      url: `/certification-test-course-ability/${certificationTestId}/items/${itemId}`,
    });
    const course = await this.fetch.fetch({
      url: `/courses/${certificationTestCourseAbility.course}`,
    });
    this.certificationTestItem = {
      certificationTestCourseAbility: { ...certificationTestCourseAbility, course },
      item,
    };
  });
}

export default LoadCertificationTestItemService;
